import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const HTML_TAG_RE = /<[^>]*>/g

export function stripHtml(html: string): string {
  return html.replace(HTML_TAG_RE, '')
}
